module.exports = __webpack_public_path__ + "img/stamp-smartphone.b1edaa91.png";